import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card, Checkbox, DatePicker, Form, Input, InputNumber, Select, Popconfirm, Upload } from 'antd';
import Chips from 'react-chips';
import Promise from 'bluebird';
import api from '../../api';
import helpers from '../../helpers'
import AppConfig from '../../config';
import FaIcon from '../../components/global/fa-icon/fa-icon';
import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import MoviePosterImage from '../../components/movie-poster-image/movie-poster-image.component';
import { setDefaultAddMovieTitle } from '../../redux/reducers/app-actions/app-actions.actions';


class MovieEditView extends Component {

  constructor(props) {
    super(props);

    this.movieHelper = helpers.movie;

    let id = _.get(this, 'props.match.params.id', null);

    this.state = {
      loaded: false,
      saving: false,
      id: id,
      data: null,
      verbose: true,
      imdbLoading: false,
    };


    this.onJsonButtonClicked = this.onJsonButtonClicked.bind(this);
    this.loadImdbMovieData = this.loadImdbMovieData.bind(this);
    this.onImdbButtonClicked = this.onImdbButtonClicked.bind(this);
    this.playYoutubeTrailer = this.playYoutubeTrailer.bind(this);
    this.onYoutubeButtonClicked = this.onYoutubeButtonClicked.bind(this);
    this.onSaveClicked = this.onSaveClicked.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);
    this.onDeleteClicked = this.onDeleteClicked.bind(this);

    this.onTitleChanged = this.onTitleChanged.bind(this);
    this.onSynopsisChanged = this.onSynopsisChanged.bind(this);
    this.onManagerNotesChanged = this.onManagerNotesChanged.bind(this);
    this.onImdbIdChanged = this.onImdbIdChanged.bind(this);
    this.onYoutubeCodeChanged = this.onYoutubeCodeChanged.bind(this);
    this.onGenreChanged = this.onGenreChanged.bind(this);
    this.onCastChanged = this.onCastChanged.bind(this);
    this.onRatingChanged = this.onRatingChanged.bind(this);
    this.onDurationChanged = this.onDurationChanged.bind(this);
    this.onReleaseDateChanged = this.onReleaseDateChanged.bind(this);
    this.on3DChanged = this.on3DChanged.bind(this);
    this.onPosterImageUploaded = this.onPosterImageUploaded.bind(this);
    this.onPosterImageDeleted = this.onPosterImageDeleted.bind(this);


    this.genreChipTheme = {
      chip: {
        color: '#722ed1',
        background: '#f9f0ff',
        border: '1px solid #d3adf7',
      }
    };
    this.castChipTheme = {
      chip: {
        color: '#13c2c2',
        background: '#e6fffb',
        border: '1px solid #87e8de',
      }
    };


    this.invalidateData(false);
  }

  async invalidateData(forceUpdate = false) {
    let id = this.state.id;

    if (forceUpdate || !this.state.loaded) {
      this.prevQuery = null;
    }
    if (this.prevQuery && _.isEqual(this.prevQuery, id)) {
      return false;
    }
    this.prevQuery = id;

    return Promise.all([
      id? api.movies.get(id): null,
      api.movies.getMPAARatingOptions(),
      api.movies.getPopularGenres(),
      api.movies.getPopularCastMembers()
    ]).then(([res, ratings, popularGenres, popularCastMembers]) => {
      let item = _.get(res, 'data') || new api.models.MovieModel();

      if (this.props.defaultAddMovieTitle) {
        if (!item.title) {
          item.title = this.props.defaultAddMovieTitle;
        }
        this.props.setDefaultAddMovieTitle(null);
      }

      this.setState({ loaded: true, data: item, ratings: ratings, popularGenres, popularCastMembers });
      return true;
    });
  }

  isAddMode() {
    return !this.state.id;
  }

  _getTargetStringValue(e, trim = false) {
    let value = _.get(e, 'target.value');
    if (trim) {
      value = _.trim(value);
    }
    if (!value || _.isEmpty(value)) { value = null; }
    return value;
  }

  onTitleChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.title = value;
    this.setState({ data });
  }

  onSynopsisChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.synopsis = value;
    this.setState({ data });
  }

  onManagerNotesChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.manager_notes = value;
    this.setState({ data });
  }

  onImdbIdChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.imdb_id = value;
    this.setState({ data });
  }

  onYoutubeCodeChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.youtube_code = value;
    this.setState({ data });
  }

  onGenreChanged(value) {
    let data = this.state.data;
    data.genreItems = value;
    this.setState({ data });
  }

  onCastChanged(value) {
    let data = this.state.data;
    data.castItems = value;
    this.setState({ data });
  }

  onRatingChanged(value, option) {
    let data = this.state.data;
    data.rating = value;
    this.setState({ data });
  }

  onDurationChanged(value) {
    let data = this.state.data;
    data.durationMinsIntValue = value;
    this.setState({ data });
  }

  onReleaseDateChanged(date, dateString) {
    let data = this.state.data;
    data.releaseDateMomentValue = date;
    this.setState({ data });
  }

  on3DChanged(e) {
    let value = !!_.get(e, 'target.checked', false);
    let data = this.state.data;
    data.is3DBooleanValue = value;
    this.setState({ data });
  }

  async onPosterImageUploaded(e) {
    let id = this.state.id;
    let res = await api.movies.get(id);
    let posterMediaId = _.parseInt(_.get(res, 'data.posterMediaIdIntValue'), 0) || null;

    if (posterMediaId > 0) {
      let data = this.state.data;
      data.posterMediaIdIntValue = posterMediaId;
      this.setState({ data });
    }
  }

  async onPosterImageDeleted(e) {
    let id = this.state.id;
    let res = await api.movies.get(id);
    let posterMediaId = _.get(res, 'data.posterMediaIdIntValue') || null;

    if (posterMediaId > 0) {
      await api.movies.deletePosterMedia(this.state);
    }

    let data = this.state.data;
    data.posterMediaIdIntValue = null;
    this.setState({ data });
  }

  onJsonButtonClicked() {
    this.printMovieJsonData(true);
  }

  printMovieJsonData(force = false) {
    if (this.state.verbose || force) {
      let movie = this.state.data;
      console.log('movie JSON obj: ');
      console.log(JSON.stringify(movie, null, 2));
      console.log('');

      // let legacyJsonObj = this.state.data.getLegacyJsonObject();
      // console.log('legacy JSON obj: ');
      // console.log(JSON.stringify(legacyJsonObj, null, 2));
      // console.log('');
    }
  }

  async loadImdbMovieData(e) {

    this.setState({ imdbLoading: true });
    let imdbId = _.get(this.state, 'data.imdb_id');
    let imdbData = await api.imdb.getMovieData(imdbId).catch(() => null);

    if (imdbData) {

      if (this.state.verbose) {
        console.log('IMDB JSON obj: ');
        console.log(JSON.stringify(imdbData, null, 2));
        console.log('');
      }

      let data = this.state.data;
      if (imdbData.title) { data.title = imdbData.title; }
      if (imdbData.synopsis) { data.synopsis = imdbData.synopsis; }
      if (imdbData.release_date) { data.release_date = imdbData.release_date; }
      if (imdbData.rating) { data.rating = imdbData.rating; }
      if (imdbData.genre) { data.genre = imdbData.genre; }
      if (imdbData.cast) { data.cast = imdbData.cast; }
      if (imdbData.duration_mins) { data.duration_mins = imdbData.duration_mins; }

      // transfer the poster image if we don't already have one
      if (imdbData.imdb_img && !data.posterMediaIdIntValue) {
        let uploadRes = await api.movies.uploadPosterMediaFromUrl(data, imdbData.imdb_img);
        let posterMediaId = _.parseInt(_.get(uploadRes, 'data.id', 0)) || null;
        data.posterMediaIdIntValue = posterMediaId;
      }

      this.setState({ data }, () => {
        this.printMovieJsonData(false);
      });
    } else {
      if (this.state.verbose) {
        console.log('IMDB JSON obj is invalid');
      }
    }

    this.setState({ imdbLoading: false });
  }

  onImdbButtonClicked(e) {
    let imdbId = _.get(this.state, 'data.imdb_id') || null;
    let movieTitle = _.get(this.state, 'data.title') || '';

    if (!_.isEmpty(imdbId)) {
      api.movies.openImdbTitleWebsite(imdbId);
    } else {
      api.movies.openImdbSearchWebsite(movieTitle);
    }
  }

  playYoutubeTrailer(e) {
    let youtubeCode = _.get(this.state, 'data.youtube_code') || null;
    let movieTitle = _.get(this.state, 'data.title') || '';

    if (youtubeCode) {
      api.movies.openYoutubeEmbedUrl(youtubeCode);
    } else {
      api.movies.openYoutubeTrailerSearchWebsite(movieTitle);
    }
  }

  onYoutubeButtonClicked(e) {
    let movieTitle = _.get(this.state, 'data.title');
    api.movies.openYoutubeTrailerSearchWebsite(movieTitle);
  }

  onSaveClicked(e) {
    let modelData = this.state.data;
    this.setState({ loaded: false, saving: true }, () => {
      api.movies.save(modelData.id, modelData).then(res => {
        let newId = _.get(res, 'data.id');
        if (this.isAddMode() && newId) {
          this.props.history.push('/movies/edit/' + newId);
        }
        this.setState({ id: newId, loaded: false, saving: false }, () => {
          this.invalidateData(true);
        });
      });
    });
  }

  onBackClicked(e) {
    this.props.history.push('/movies');
  }

  onCancelClicked(e) {
    this.onBackClicked();
  }

  onDeleteClicked(e) {
    let modelData = _.cloneDeep(this.state.data);
    this.setState({ loaded: false, saving: true }, () => {
      api.movies.remove(modelData.id).then(res => {
        this.props.history.push('/movies');
      });
    });
  }


  render() {

    let id = _.get(this, 'state.data.id') || _.get(this, 'state.id') || null;
    let isEditMode = !!id;
    let canDelete = isEditMode;

    let title = isEditMode? ('Edit Movie ' + id): 'Add Movie';

    let titleActions = (
      <div className="title-actions">
        <Button type="default" size="large" icon={<FaIcon icon="fa-arrow-alt-left" />} onClick={this.onBackClicked}>Back</Button>
        <div className="title-text">{title}</div>
      </div>
    );

    let actions = (
      <div className="card-actions action-buttons">
        {AppConfig.dbgMode? (
          <Button type="default" size="large" icon={<FaIcon icon="fa-brackets-curly" />} onClick={this.onJsonButtonClicked}>JSON</Button>
        ): null }
        { canDelete? (
          <Popconfirm title="Are you sure you want to delete this movie?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={this.onDeleteClicked}>
            <Button type="danger" size="large" icon={<FaIcon icon="fa-trash" />}>Delete</Button>
          </Popconfirm>
        ) : null }
        <div className="ml-3">&nbsp;</div>
        <Button type="default" size="large" icon={<FaIcon icon="fa-times"/>} onClick={this.onCancelClicked}>Cancel</Button>
        <Button type="primary" size="large" icon={<FaIcon icon="fa-check"/>} onClick={this.onSaveClicked}>Save</Button>
      </div>
    );

    return (
      <div className="movie-edit-view mx-auto" >
        <Card title={titleActions} extra={actions}>
          <div className="page-content">
            { (!this.state.loaded)? <LoadingSpinner />: null }

            { (this.state.loaded)? this.renderEditArea(): null }

            { (false && this.state.loaded)? this.renderJsonData(): null }
          </div>
        </Card>
      </div>
    );
  }

  renderEditArea() {
    let isAddMode = !this.state.id;
    let data = this.state.data;
    let hasPoster = (data && data.posterMediaIdIntValue > 0)
    let posterUploadUrl = api.movies.getPosterUploadUrl(data);
    let ratings = this.state.ratings;
    let imdbLoading = this.state.imdbLoading;

    return (
      <Form className="edit-movie-content d-flex flex-sm-row flex-column" layout="vertical">

        <div className="poster-area text-center center d-flex flex-column">

          <div className="poster-container">
            <div className="action-buttons">
              { hasPoster? (
                <Button type="danger" size="large" shape="circle" icon={<FaIcon icon="fa-times" />} onClick={this.onPosterImageDeleted} />
              ): null }
            </div>
            <MoviePosterImage movie={data} />
          </div>

          <div className="poster-upload mt-3">
            <Upload.Dragger
              name="file"
              disabled={isAddMode}
              multiple={false}
              action={posterUploadUrl}
              onChange={this.onPosterImageUploaded}
            >
              <p className="ant-upload-drag-icon">
                <span className="fas faw fa-3x fa-upload"></span>
              </p>
              <p className="ant-upload-text">Click or drag file to upload</p>
              {isAddMode? (
                <p className="ant-upload-hint">
                  Warning! You must save the movie before uploading any artwork.
                </p>
              ): null }
            </Upload.Dragger>
          </div>
        </div>
        <div className="details-area container-fluid">

          <div className="row">
            <div className="col-sm-8 col-12">
              <Form.Item label="Title" colon={false}>
                <Input value={data.title} onChange={this.onTitleChanged} />
              </Form.Item>
            </div>

            <div className="col-sm-4 col-12">
              <Form.Item label="IMDB Movie ID" colon={false}>
                <Input.Group compact className="d-flex flex-row fillx">
                  <Input className="flex-fill" value={data.imdb_id} onChange={this.onImdbIdChanged} />
                  <Button className="m-0 pt-1 pb-1 pr-2 pl-2" style={{ width: '32px' }} onClick={this.loadImdbMovieData}>
                    <span className={"imdb-button-icon fas faw fa-1-5x fa-sync" + (imdbLoading? " fa-spin loading": "")} />
                  </Button>
                  <Button className="m-0 ml-3 p-0" style={{ width: '120px' }} onClick={this.onImdbButtonClicked}>
                    <img src={require('../../assets/images/imdb_66x32.png')} alt="IMDB logo" />
                    <span className="icon-link fa faw fa-external-link"></span>
                  </Button>
                </Input.Group>
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-8 col-12">
              <Form.Item className="chips-offset-first-child" label="Genre" colon={false}>
                <Chips value={data.genreItems}
                       suggestions={this.state.popularGenres}
                       placeholder="Add Genre"
                       uniqueChips={true}
                       chipTheme={this.genreChipTheme}
                       onChange={this.onGenreChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="YouTube Trailer Code" colon={false}>
                <Input.Group compact className="d-flex flex-row fillx">
                  <Input className="flex-fill" value={data.youtube_code} onChange={this.onYoutubeCodeChanged} />
                  <Button className="m-0 pt-1 pb-1 pr-2 pl-2" style={{ width: '32px' }} onClick={this.playYoutubeTrailer}>
                    <span className="fas faw fa-1-5x fa-play" />
                  </Button>
                  <Button className="m-0 ml-3 p-0" style={{ width: '120px' }} onClick={this.onYoutubeButtonClicked}>
                    <img src={require('../../assets/images/youtube_77x32.png')} alt="YouTube logo" />
                    <span className="icon-link fa faw fa-external-link"></span>
                  </Button>
                </Input.Group>
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-8 col-12">
              <Form.Item className="chips-offset-first-child" label="Cast" colon={false}>
                <Chips
                  value={data.castItems}
                  suggestions={this.state.popularCastMembers}
                  placeholder="Add Cast"
                  uniqueChips={true}
                  chipTheme={this.castChipTheme}
                  onChange={this.onCastChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="Release Date" colon={false}>
                <DatePicker
                  className="fillx"
                  format={'ddd M/D/YYYY'}
                  allowClear={false}
                  value={data.releaseDateMomentValue}
                  onChange={this.onReleaseDateChanged} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4 col-12">
              <Form.Item label="MPAA Rating" colon={false}>
                <Select value={data.rating} onChange={this.onRatingChanged}>
                  {_.map(ratings, (rating, idx) => {
                    return (<Select.Option key={idx} value={rating.value}>{rating.label}</Select.Option>);
                  })}
                </Select>
              </Form.Item>
            </div>

            <div className="col-sm-4 col-12">
              <Form.Item label="Duration" colon={false} help={this.movieHelper.formatDurationValue(data.durationMinsIntValue)}>
                <InputNumber className="fillx" min={1} max={1440} value={data.durationMinsIntValue} onChange={this.onDurationChanged}/>
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="Supports 3D" colon={false}>
                <Checkbox checked={data.is3DBooleanValue} onChange={this.on3DChanged}>Is 3D Movie?</Checkbox>
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-12">
              <Form.Item label="Synopsis" colon={false}>
                <Input.TextArea rows={4} value={data.synopsis} onChange={this.onSynopsisChanged} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-12">
              <Form.Item label="Optional Manager Notes" colon={false}>
                <Input.TextArea rows={3} value={data.manager_notes} onChange={this.onManagerNotesChanged} />
              </Form.Item>
            </div>
          </div>

        </div>
      </Form>
    );
  }

  renderJsonData() {
    return (
      <pre>{ JSON.stringify(this.state.data, null, 2) }</pre>
    );
  }

}



function mapStateToProps(state) {
  return {
    auth: state.auth,
    defaultAddMovieTitle: state.appActions.defaultAddMovieTitle,
  };
}


const mapDispatchToProps = {
  setDefaultAddMovieTitle,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MovieEditView));

